// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-module--container--SePS1"};